import React, { useEffect, useRef } from 'react';
import _ from 'lodash';

export const useDeepCompareEffect = (callback, dependencies) => {
    const previousDependencies = useRef();
    const cleanup = useRef();
    const isDifferent = !_.isEqual(previousDependencies.current, dependencies);

    useEffect(() => {
        if (isDifferent) {
            if (typeof cleanup.current === 'function') {
                cleanup.current();
            }
            cleanup.current = callback();
        }
        previousDependencies.current = dependencies;
    }, [callback, isDifferent, dependencies]);
};
